var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPracticalLearningWithExtendedSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m400.072 178.066h-288.146s-18.432 64.644-19.12 158.059c-.026 3.49 1.639 6.768 4.488 8.785 14.612 10.347 65.221 40.901 158.706 45.5 93.485-4.599 144.094-35.153 158.706-45.5 2.848-2.017 4.513-5.295 4.488-8.785-.691-93.415-19.122-158.059-19.122-158.059z",
    fill: "#685e67"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#554e55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m419.189 336.127c.031 3.492-1.638 6.768-4.481 8.787-5.326 3.77-15.422 10.219-30.627 17.122 2.647-2.246 4.172-5.614 4.141-9.21-.659-94.189-17.018-163.561-19.81-174.759h31.657s18.43 64.644 19.12 158.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m411.566 235.953-148.902 49.242c-4.327 1.432-9.004 1.432-13.33 0l-148.902-49.242c5.336-36.283 11.497-57.886 11.497-57.886h288.14s6.16 21.603 11.497 57.886z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m249.329 77.075-242.043 80.043c-9.715 3.213-9.715 16.956 0 20.168l242.043 80.043c4.331 1.432 9.008 1.432 13.339 0l242.043-80.043c9.715-3.213 9.715-16.956 0-20.168l-242.043-80.043c-4.331-1.432-9.008-1.432-13.339 0z",
    fill: "#918291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m504.714 177.284-242.05 80.045c-4.327 1.432-9.004 1.432-13.33 0l-36.561-12.094c2.895.227 5.82-.124 8.612-1.051l264.858-87.586c2.205-.721 3.544-2.39 4.007-4.265l14.464 4.78c9.715 3.214 9.715 16.957 0 20.171z",
    fill: "#7a6e79"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m283.068 154.892c0 10.258-12.164 14.326-27.17 14.326s-27.17-4.068-27.17-14.326 12.164-18.574 27.17-18.574 27.17 8.316 27.17 18.574z",
    fill: "#685e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.072 154.888c0 10.261-12.166 14.33-27.176 14.33-1.473 0-2.915-.041-4.327-.124 5.882-2.236 9.622-6.027 9.622-11.713 0-8.643-8.623-15.896-20.305-17.977 4.296-1.947 9.457-3.091 15.01-3.091 15.009.001 27.176 8.325 27.176 18.575z",
    fill: "#554e55"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m143.173 293.949c-4.268 0-7.726-3.459-7.726-7.726v-63.999c0-2.593 1.301-5.013 3.463-6.443l89.263-59.069c3.556-2.356 8.351-1.379 10.707 2.18 2.354 3.558 1.378 8.352-2.18 10.707l-85.8 56.778v59.847c-.001 4.265-3.459 7.725-7.727 7.725z",
    fill: "#433f43"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m137.717 276.236c-7.392 15.925-19.719 55.325-20.076 141.415-.01 2.358 1.587 4.415 3.87 5.004 4.301 1.109 11.934 2.616 21.661 2.616s17.361-1.507 21.661-2.616c2.283-.589 3.88-2.645 3.87-5.004-.357-86.09-12.684-125.49-20.076-141.415z",
    fill: "#fdd330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.702 417.655c.01 2.349-1.587 4.409-3.863 4.996-3.987 1.03-10.817 2.39-19.511 2.586 1.185-.958 1.916-2.411 1.906-4.007-.288-69.496-8.375-108.57-15.37-129.421 2.081-6.717 4.1-11.806 5.851-15.576h10.91c7.395 15.926 19.726 55.33 20.077 141.422z",
    fill: "#e7b729"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 143.173,
    cy: 275.175,
    fill: "#fddd45",
    r: 21.471
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m501.873 343.531c10.232-3.724 13.201-21.374 6.632-39.422s-20.189-29.66-30.42-25.936l-252.143 91.773 23.788 65.358z",
    fill: "#f2eff2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m508.5 304.107c6.571 18.054 3.609 35.697-6.624 39.422l-252.148 91.774-8.911-24.482 246.978-89.893c9.894-3.601 12.992-20.208 7.263-37.604 5.354 4.706 10.239 11.984 13.442 20.783z",
    fill: "#e1dde1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 237.837,
    cy: 402.625,
    fill: "#b5adb6",
    rx: 19.715,
    ry: 34.776,
    transform: "matrix(.94 -.342 .342 .94 -123.363 105.626)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249.726 435.303c-4.77 1.741-10.292.134-15.473-3.904 6.696-4.533 8.283-17.771 3.369-31.287-4.316-11.868-12.331-20.336-19.676-21.675 1.7-4.162 4.399-7.18 7.994-8.489 10.23-3.729 23.859 7.881 30.421 25.93 6.572 18.049 3.605 35.706-6.635 39.425z",
    fill: "#a69ca7"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m369.153 391.837c10.232-3.724 13.201-21.374 6.632-39.422s-20.189-29.66-30.42-25.936l35.101-12.776c10.232-3.724 23.851 7.888 30.42 25.936s3.6 35.698-6.632 39.422c0 0 33.707-4.85 47.398 21.191 1.441 2.742.085 6.132-2.826 7.191l-35.458 12.906c-2.675.974-5.637-.401-6.601-3.079-3.794-10.537-14.935-33.687-37.614-25.433z",
    fill: "#fc9744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.285 348.048c3.055 14.839-.411 27.875-9.027 31.011l-35.101 12.776c8.625-3.139 12.092-16.175 9.027-31.011z",
    fill: "#fb7722"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPracticalLearningWithExtendedSupport);
export default __webpack_public_path__ + "static/media/Practical-learning-with-extended-support.08b1fb1c06a45eff86daecd27fc5ae89.svg";
export { ForwardRef as ReactComponent };